module.exports = __webpack_public_path__ + "static/media/journey-cloud-large.9c500156.svg";